import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { trigger, transition, style, animate } from '@angular/animations';
import { Router } from '@angular/router';
import { FirebaseMessagingService, InAppNotification } from 'src/app/services/firebase-messaging.service';
import { Capacitor } from '@capacitor/core';
@Component({
  selector: 'app-in-app-notification',
  templateUrl: './in-app-notification.component.html',
  styleUrls: ['./in-app-notification.component.scss'],
  animations: [
      trigger('slideDown', [
          transition(':enter', [
              style({ transform: 'translateY(-100%)', opacity: 0 }),
              animate('300ms ease-out', style({ transform: 'translateY(0)', opacity: 1 }))
          ]),
          transition(':leave', [
              animate('300ms ease-in', style({ transform: 'translateY(-100%)', opacity: 0 }))
          ])
      ])
  ],
  standalone: false
})
export class InAppNotificationComponent implements OnInit, OnDestroy {
  showBanner = true;
  notification: InAppNotification | null = null;
  isDragging = false;
  isIOS = Capacitor.getPlatform() === 'ios';
  private subscription: Subscription = new Subscription();
  private hideTimeout: any;
  private startY = 0;
  private currentY = 0;
  private threshold = 50;

  constructor(
    private firebaseMessaging: FirebaseMessagingService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.firebaseMessaging.notification$.subscribe(notification => {
        if (notification) {
          this.showNotification(notification);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  private showNotification(notification: InAppNotification): void {
    this.notification = notification;
    this.showBanner = true;

    this.hideTimeout = setTimeout(() => {
      this.dismiss();
    }, 3500);
  }

  dismiss(): void {
    this.showBanner = false;
    this.notification = null;
    this.isDragging = false;
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }
  }

  onTouchStart(event: TouchEvent): void {
    this.startY = event.touches[0].clientY;
    this.currentY = this.startY;
    this.isDragging = true;
  }

  onTouchMove(event: TouchEvent): void {
    if (!this.isDragging) return;

    this.currentY = event.touches[0].clientY;
    const deltaY = this.startY - this.currentY;

    if (deltaY > 0) {
      event.preventDefault();
    }
  }

  onTouchEnd(event: TouchEvent): void {
    if (!this.isDragging) return;

    const deltaY = this.startY - this.currentY;

    if (deltaY > this.threshold) {
      this.dismiss();
    }

    this.isDragging = false;
  }

  onNotificationClick(): void {
    this.dismiss();
    this.router.navigate(['/inbox']);
  }
}
